module.exports = __webpack_public_path__ + "img/JA_logo.1ee9f606.svg";